<template>
    <div>
        <h1>Compras por Proveedor</h1>
        <v-row>
            <v-col cols="12" md="4">
                <v-alert type="info"> Próximamente</v-alert>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "reporte.compra.proveedor",
        data() {
            return {

            };
        },
        methods: {          
        },
    }
</script>

<style lang="scss" scoped>

</style>